import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Feedback from "../../../components/feedbackNote/Feedback";
import { GetHomeData, selectHomeData } from "../../../features/home/homeSlice";
import { GetLogsTracker, selectLogsTracker } from "../../../features/login/logsTracker";

// const userData: any = {
//   profileImage:
//     "https://dummyimage.com/200x200/d4d4d4/0011ff.png&text=Profile+Photo",
//   fullName: "Samir Bhor",
//   designation: "GCO",
//   grade: "Sr. General Manager",
//   email: "garimarai@gmail.com",
//   empId: "1234567",
//   phoneNo: "9876543210",
//   organization: {
//     unit: "Group Corporate Office",
//     subUnit: "Group Technology Office",
//     projectCode: "12345",
//     reportingManager: "Ravi Shankar",
//   },
// };

const Profile = () => {
  const homeData = useAppSelector(selectHomeData);
  let userData=homeData?.user
  const dispatch = useAppDispatch();
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  useEffect(() => {
    async function fetchUser() {
      let sample = await dispatch(GetHomeData(userDetailsJson));
    }
    fetchUser();
  }, []);
//console.log("user profile ===============> ", userData.name);
const LogsTracker = useAppSelector(selectLogsTracker);
var moduleName="Profile"
useEffect(() => {
  async function fetchLogsTracker() {
    let sample = await dispatch(GetLogsTracker(moduleName));
  }
  fetchLogsTracker();
}, []);
  return (
    <>
      <h2>Profile</h2>
      <Feedback pageName="profile"/>
      <Container className="px-0" fluid>
        <Row className="mx-0">
          <Col sm={2} xs={12} className="desk ps-0 mb-3">
            <Card
              className="text-black shadow"
              style={{
                width: "100%",
                borderRadius: "0",
                padding: "0px",
                backgroundColor: "white",
              }}
            >
              <Card.Body style={{ padding: "0px" }}>
                <Row className="mx-0 py-0">
                  <Col className="px-0" sm={12} xs={3}>
                    <Card.Img
                      className="desk"
                      src={userData?.userPhoto}
                      style={{ height: "200px", borderRadius: "0" }}
                    />
                    <Card.Img
                      className="mob"
                      src={userData?.userPhoto}
                      style={{ height: "80px", borderRadius: "0" }}
                    />
                  </Col>
                  <Col className="mt-3 mb-2" sm={12} xs={5}>
                    <Card.Title style={styles.ctitle}>
                      {userData?.name}
                    </Card.Title>
                    <Card.Text style={styles.ctext}>
                      {userData?.designation}
                    </Card.Text>
                  </Col>
                  <Col className="mt-3 mb-2" sm={12} xs={5}>
                  <a href="/ChangePassword"><label style={styles.head}>Change Password</label></a>  
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={2} xs={12} className="mob px-0 mb-3">
            <Card
              className="text-black shadow"
              style={{
                width: "100%",
                borderRadius: "0",
                padding: "0px",
                backgroundColor: "white",
              }}
            >
              <Card.Body style={{ padding: "0px" }}>
                <Row className="mx-0 py-0">
                  <Col className="px-0" sm={12} xs={3}>
                    <Card.Img
                      className="desk"
                      src={userData?.userPhoto}
                      style={{ height: "200px", borderRadius: "0" }}
                    />
                    <Card.Img
                      className="mob"
                      src={userData?.userPhoto}
                      style={{ height: "80px", borderRadius: "0" }}
                    />
                  </Col>
                  <Col className="mt-3 mb-2" sm={12} xs={5}>
                    <Card.Title style={styles.ctitle}>
                      {userData?.name}
                    </Card.Title>
                    <Card.Text style={styles.ctext}>
                      {userData?.designation}
                    </Card.Text>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={10} xs={12} className="px-0">
            <Container className="py-3 bg-white shadow text-black" fluid>
              <Row md={4} className="py-0">
                <Col xs={12} className="py-2">
                  <div style={styles.title}>Grade</div>
                  <div style={styles.info}>{userData?.grade}</div>
                </Col>
                <Col md={4} xs={12} className="py-2">
                  <div style={styles.title}>Email</div>
                  <div style={styles.info}>{userData?.emailId}</div>
                </Col>
                <Col md={2} xs={12} className="py-2">
                  <div style={styles.title}>Emp ID</div>
                  <div style={styles.info}>{userData?.employeeId}</div>
                </Col>
                <Col xs={12} className="py-2">
                  <div style={styles.title}>Phone no.</div>
                  <div style={styles.info}>{userData?.mobileNo}</div>
                </Col>
              </Row>
            </Container>

            <Container
              className="py-2 mt-1 bg-white shadow text-black"
              fluid
              style={{ padding: "16px 12px" }}
            >
              <Row md={4} className="pt-2">
                <Col xs={12} style={styles.head} className="ms-2">
                  Org Details
                </Col>
              </Row>
              <Row>
                <div style={styles.line}></div>
              </Row>
              <Row md={4} className="pb-0 ms-0">
                <Col xs={12} className="py-2">
                  <div style={styles.title}>Unit</div>
                  <div style={styles.info}>{userData?.unit}</div>
                </Col>
                <Col md={4} xs={12} className="py-2">
                  <div style={styles.title}>Sub-unit</div>
                  <div style={styles.info}>{userData?.subUnit}</div>
                </Col>
                <Col md={2} xs={12} className="py-2">
                  <div style={styles.title}>Project code</div>
                  <div style={styles.info}>
                    {userData?.projectCode}
                  </div>
                </Col>
                <Col md={2} xs={12} className="py-2">
                  <div style={styles.title}>Reporting Manager</div>
                  <div style={styles.info}>
                    {userData?.projectManager}
                  </div>
                </Col>
              </Row>

              <Row>
                <div style={styles.line}></div>
              </Row>
              {/* <Row md={4}>
                <Col xs={12} style={styles.head}>
                <a href="/AssignRole"> <label style={styles.head}>Assign Role</label></a>
                </Col>
              </Row> */}
             
            
            </Container>

          
          </Col>
        </Row>
      </Container>
    </>
  );
};

const styles: any = {
  line: {
    margin: "23px 0px",
    backgroundColor: "#d8d8d8",
    height: "1.5px",
    padding: "0px",
  },
  head: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "600",
    Pointer:"hand",
    color:"#000000",
  },
  title: {
    fontFamily: "Saira",
    fontSize: "12px",
    color: "#6d6e71",
    fontWeight: "500",
  },
  info: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
  },
  ctitle: {
    alignSelf: "stretch",
    fontFamily: "Saira",
    fontSize: "20px",
  },
  ctext: {
    alignSelf: "stretch",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
};

export default Profile;
